/**
 * A `cardapnator` guarda a configuração do cardápio em variáveis GLOBAIS (`globalThis.StockConfiguration`,
 * `Combo`, `MenuTypeConfiguration`, `isOnlyTableProducts`...) e o `build()` as regrava campo por campo.
 * Quando a loja não tem `info.stock_configuration` (87% das lojas, medido em 23/09/2026), a 2ª
 * atribuição lança, o `catch` só loga "[Cardapnator] - Erro ao inicializar o stockConfiguration", e as
 * pausas de estoque e o arredondamento de combo ficam com o valor da loja montada ANTES.
 *
 * No navegador, página nova, "antes" são os padrões — nada acontece. Na Lambda do SSR um processo monta
 * milhares de lojas em sequência: a `superpizzagigante` (estoque ligado, sem configuração, refrigerante
 * zerado) perdia a categoria BEBIDAS quando era montada depois da `brasaburger` (pausa ao zerar). A
 * página dependia da ORDEM das montagens. No navegador, o mesmo acontece ao trocar de loja sem recarregar.
 *
 * Por isso: antes de cada `new Cardapnator`, os globais voltam aos padrões da própria lib
 * (`cardapnator/globals.js`). Os que o chamador escolhe (tipo de menu, só mesa/só delivery) são
 * regravados logo depois por `setMenuType`/`onlyTableProducts`/`onlyDeliveryProducts`.
 */
export function zerarConfiguracaoGlobalDaCardapnator(): void {
	const g = globalThis as any;
	g.MenuTypeConfiguration = 'all';
	g.TimeZoneConfiguration = null;
	g.isOnlyTableProducts = false;
	g.isOnlyDeliveryProducts = false;
	g.isPos = false;
	// Object.assign: mantém o MESMO objeto, caso alguém tenha guardado a referência.
	g.StockConfiguration = Object.assign(g.StockConfiguration || {}, {
		stockIsEnabled: false,
		pauseStockItemsAutomatically: false,
		pauseWhenStockRunsOut: false,
		pauseWhenStockReachesSafetyInterval: false,
		generalInterval: false,
		categorySpecificInterval: false,
		itemSpecificInterval: false,
		pauseStockAt: 0,
	});
	g.RecipeStockConfig = Object.assign(g.RecipeStockConfig || {}, { enableStock: false, pauseWhenLessThanZero: false });
	g.SupplyStockConfiguration = Object.assign(g.SupplyStockConfiguration || {}, {
		enabled: false,
		enableStock: false,
		pauseWhenLessThanZero: false,
		pauseWhenReachesMinimumQuantity: false,
		pauseWhenReachesSafetyInterval: false,
		generalInterval: false,
		generalMinimumQuantity: 0,
		categorySpecificInterval: false,
	});
	g.Combo = Object.assign(g.Combo || {}, { roundType: null, roundStep: 0.05 });
}
